<template>
    <v-container fill-height justify-center v-if="progress">
        <div class="text-center">
            <v-progress-circular
              :rotate="2"
              :size="100"
              :width="10"
              color="primary"
              indeterminate
            >
            </v-progress-circular>
        </div>
    </v-container>

    <v-container fluid fill-height v-else>
        <v-layout justify-center row pa-5 v-if="items.length > 0">
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-3" text-center>
                    <h2>รายการพัสดุ</h2>
                </v-flex>
                <div class="my-2" v-for="(item, key) in items">
                    <v-card class="mx-auto my-2"
                            v-if="(item.ORDER_STATUS == null || item.ORDER_STATUS == 0) && (item.ST_REMARK == 'กล่องใหญ่พิเศษ' || item.ST_REMARK == 'ห่อใหญ่พิเศษ')"
                            style="border-left:solid 5px #ff2e34;background: #f3f4f6">
                        <v-row>
                            <v-col class="text-center my-auto" cols="3">
                                <v-icon large color="red darken-2">
                                    mdi-package-variant-closed
                                </v-icon>
                                <br>
                                <span class="overline font-weight-bold"
                                      style="color: #ff2e34">
                                    ใส่ตู้ไม่ได้
                            </span>
                            </v-col>
                            <v-col cols="7">
                                <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                <v-card-text style="color: #000000"
                                             v-if="item.CS_MOBILE != '' && item.CS_MOBILE != null">
                                    เบอร์โทร : {{ item.CS_MOBILE_SHOW }}
                                </v-card-text>
                                <v-card-text style="color: #ff2e34" v-else>ไม่พบเบอร์โทร</v-card-text>
                                <v-card-text style="color: #ff2e34">เลขที่อ้างอิง : {{ item.SU_CODE }}
                                </v-card-text>
                                <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>
                                <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                            </v-col>
                            <v-col cols="2" class="text-center my-auto">
                                <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold
                                </v-icon>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="mx-auto my-2"
                            @click="selectedParcel(items, key, item.SU_RUNNO)"
                            v-else
                            style="border-left:solid 5px #0045AF;background: #f3f4f6">
                        <v-row>
                            <v-col class="text-center my-auto" cols="3">
                                <v-icon large color="blue darken-2">
                                    mdi-package-variant-closed
                                </v-icon>
                                <br>
                                <span v-if="item.ORDER_STATUS"
                                      class="overline font-weight-bold"
                                      style="color: #0045AF">
                                    รอเข้าตู้
                            </span>
                            </v-col>
                            <v-col cols="7">
                                <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                <v-card-text style="color: #000000"
                                             v-if="item.CS_MOBILE != '' && item.CS_MOBILE != null">
                                    เบอร์โทร : {{ item.CS_MOBILE_SHOW }}
                                </v-card-text>
                                <v-card-text style="color: #ff2e34" v-else>ไม่พบเบอร์โทร</v-card-text>
                                <v-card-text style="color: #ff2e34">เลขที่อ้างอิง : {{ item.SU_CODE }}
                                </v-card-text>
                                <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>
                                <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                            </v-col>
                            <v-col cols="2" class="text-center my-auto">
                                <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold
                                </v-icon>
                            </v-col>
                        </v-row>
                    </v-card>
                    <!--                    <v-card class="mx-auto my-2"-->
                    <!--                            v-else-->
                    <!--                            style="border-left:solid 5px #4CAF50;background: #f3f4f6">-->
                    <!--                        <v-row>-->
                    <!--                            <v-col class="text-center my-auto" cols="3">-->
                    <!--                                <v-icon large color="green darken-2"-->
                    <!--                                >mdi-package-variant-closed-->
                    <!--                                </v-icon>-->
                    <!--                                <br>-->
                    <!--                                <span class="overline font-weight-bold"-->
                    <!--                                      style="color: #0045AF">อยู่ในตู้</span>-->
                    <!--                            </v-col>-->
                    <!--                            <v-col cols="7">-->
                    <!--                                <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>-->
                    <!--                                <v-card-text style="color: #000000"-->
                    <!--                                             v-if="item.CS_MOBILE != '' && item.CS_MOBILE != null">-->
                    <!--                                    เบอร์โทร : {{ item.CS_MOBILE_SHOW }}-->
                    <!--                                </v-card-text>-->
                    <!--                                <v-card-text style="color: #ff2e34" v-else>ไม่พบเบอร์โทร</v-card-text>-->
                    <!--                                <v-card-text style="color: #ff2e34">เลขที่อ้างอิง : {{ item.SU_CODE }}-->
                    <!--                                </v-card-text>-->
                    <!--                                <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>-->
                    <!--                                <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>-->
                    <!--                                <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>-->
                    <!--                            </v-col>-->
                    <!--                            <v-col cols="2" class="text-center my-auto">-->
                    <!--                                <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold-->
                    <!--                                </v-icon>-->
                    <!--                            </v-col>-->
                    <!--                        </v-row>-->
                    <!--                    </v-card>-->
                </div>
                <div>
                    <v-btn color="#1565C0"
                           block
                           large
                           dark
                           @click="dialog2 = true"
                           class="mt-5">
                        ยืนยันการนำพัสดุเข้าตู้({{ itemSelected.length }})
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-layout justify-center row pa-5 v-else>
            <v-flex class="mb-3" text-center>
                <h2>ไม่มีรายการพัสดุ</h2>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="290" persistent>
            <v-card>
                <v-card-title
                >ยืนยันการนำพัสดุเข้าตู้ <br/>เลขอ้างอิง
                    {{ itemSelected.SU_CODE }}
                </v-card-title
                >
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1" text @click="save()">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1" text @click="dialog = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_mobile" max-width="290" persistent>
            <v-card>
                <v-card-title>{{ message }}</v-card-title>
                <v-card-text style="color: #ff2e34"
                >* หมายเหตุเบอร์โทรนี้ใช้ในการส่ง SMS สำหรับเปิดตู้
                </v-card-text
                >
                <v-card-text>
                    <v-text-field label="หมายเลขโทรศัพท์"
                                  placeholder="08xxxxxxxx"
                                  outlined
                                  v-model="itemSelectedCheck"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1" text @click="addNewOrder(itemSelected);">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1" text @click="dialog_mobile = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog2" max-width="290">
            <v-card>
                <v-card-title class="headline">รายการที่เลือก</v-card-title>
                <v-card class="mx-auto"
                        max-width="400"
                        tile
                        v-for="(item, key) in itemSelectedShow" :key="key">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="save()">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1"
                           text
                           @click="dialog2 = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import EventBus from "@/EventBus";
import axios_box24 from "@/axios_box24";
import axios from "@/axios";

export default {
    name: "AddNewOrderBox24",
    data() {
        return {
            searchData: {
                ntRunno: this.getLocalItem().nt_runno,
                status: "'W'",
            },
            items: [],
            itemSelected: [],
            itemSelectedShow: [],
            itemSelectedCheck: "#",
            progress: true,
            dialog: false,
            dialog2: false,
            dialog_mobile: false,
            today: new Date().toISOString().substr(0, 10),
            api_token: "",
            mobileNumber: "",
            message: ""
        };
    },
    mounted() {
        window.scrollTo(0, 0);
        EventBus.$emit("set_navigation", {
            title: "รายการพัสดุนอกเวลา",
            back_route: "size-box24",
        });
        let localItem = this.getLocalItem();

        delete localItem.itemSelected;
        localStorage.setItem("parcel", JSON.stringify(localItem));

        try {
            this.getTokenBox24()
              .then((res) => {
                  this.api_token = res.data.data.api_token;

                  this.listParcelOT();
              })
              .catch((err) => {
                  if (err.response) {
                      this.error.status = err.response.data.status;
                      this.error.error_code = err.response.status;
                      if (err.response.status === 401) {
                          this.error.msg = "ชื่อผู้ใช้งาน หรือ รหัสผ่าน Box24 ไม่ถูกต้อง";
                      } else {
                          this.error.msg = err.response.data.msg;
                      }

                      console.log(this.error);
                  }
              });
        } catch (err2) {
            console.log(err2.message);
        }
    },
    methods: {
        // selectedParcel(data) {
        //     this.itemSelected = data;
        //     console.log("selectedParcel", this.itemSelected);
        //     this.dialog = true;
        // },
        selectedParcel(array, index, data) {
            if (this.itemSelectedCheck == "#") {
                // console.log('length', '#')
                this.itemSelectedCheck = array[index].CS_MOBILE
                this.itemSelectedShow.push(array[index].SU_CODE)
                array[index].CLICK = '1'
                this.itemSelected.push(data)
            } else {
                if (this.itemSelectedCheck == array[index].CS_MOBILE) {
                    // console.log('itemSelectedCheck', array[index].CS_MOBILE)
                    if (array[index].CLICK == '1') {
                        array[index].CLICK = '0'
                        this.removeItem(this.itemSelected, data)
                        this.removeItem(this.itemSelectedShow, array[index].SU_CODE)
                    } else {
                        array[index].CLICK = '1'
                        this.itemSelected.push(data)
                        this.itemSelectedShow.push(array[index].SU_CODE)
                    }
                } else {
                    // console.log('mobile !=', array[index].CS_MOBILE)
                    this.itemSelected = []
                    this.itemSelectedShow = []
                    this.itemSelectedCheck = array[index].CS_MOBILE
                    array.forEach(function (value) {
                        value.CLICK = '0'
                    })
                    array[index].CLICK = '1'
                    this.itemSelected.push(data)
                    this.itemSelectedShow.push(array[index].SU_CODE)
                }
            }
            // console.log('selectedParcel', this.itemSelected)
            // console.log('selectedParcel', this.itemSelectedShow)
            // console.log('selectedParcel', this.itemSelectedCheck)
        },
        goto(route_name) {
            return this.$router.push({name: route_name});
        },
        save() {
            if (this.itemSelectedCheck !== '' || this.mobileNumber !== '') {
                this.mobileNumber = this.itemSelectedCheck
                this.message = "หมายเลขโทรศัพท์"
                this.dialog_mobile = true
            } else {
                this.message = "รายการนี้ไม่มีหมายเลขโทรศัพท์"
                this.dialog_mobile = true
            }
        },
        async listParcelOT() {
            try {
                axios.post("/OTParcelList", this.searchData).then((res) => {
                    console.log('ParcelList', res.data.data)
                    this.items = res.data.data;

                    let localItem = this.getLocalItem();
                    localItem.itemsParcel = res.data.data;
                    localStorage.setItem("parcel", JSON.stringify(localItem));

                    this.progress = false;

                    // console.log('groupsDate', this.groupByData(this.items, 'REQUEST_DATE'))
                });
            } catch (err) {
                console.log(err.message);
            }
        },
        async addNewOrder(data) {
            let bodyFormData = new FormData();
            let mobile = this.itemSelectedCheck
            let localItem = this.getLocalItem();

            bodyFormData.set("api_token", this.api_token);
            bodyFormData.set("location_id", this.getLocalItem().box24_location_id);
            bodyFormData.set("size_id", this.getLocalItem().box24_size_id);
            bodyFormData.set("start_date", new Date().toISOString().substr(0, 10));
            bodyFormData.set("country_id", "1");

            // if (this.itemSelectedCheck !== '#' && this.itemSelectedCheck !== '' && this.itemSelectedCheck !== null) {
            //     mobile = this.itemSelectedCheck
            // } else {
            //     mobile = this.mobileNumber
            // }
            // console.log("addNewOrder", data);

            bodyFormData.set("mobile_number", mobile.replace(' ', ''));

            try {
                axios_box24
                  .post("/dropbox24/new-order", bodyFormData)
                  .then((res) => {
                      // console.log("dropbox24_addNewOrder", res.data.data);
                      // this.size_boxs = res.data.data
                      localItem.box24_order_id = res.data.data.order_id
                      localItem.box24_mobile = mobile
                      let location_id = localItem.box24_location_id
                      localStorage.setItem("parcel", JSON.stringify(localItem));

                      data.forEach(function (value) {
                          let fromData = {
                              su_runno: value,
                              order_id: res.data.data.order_id,
                              drop_quickpin: res.data.data.drop_quickpin,
                              pickup_quickpin: res.data.data.pickup_quickpin,
                              username: localItem.user_id,
                              mobile_number: mobile,
                              location_id: location_id
                          };
                          try {
                              axios.post("/UpdateOrderId", fromData).then((ress) => {
                                  console.log("UpdateOrderId", ress);
                              });
                          } catch (err) {
                              console.log(err.message);
                          }
                      })
                      this.goto("barcode-order-box24");
                  });
            } catch (err) {
                console.log(err.message);
            }
        },
    },
};
</script>
